import React, { useEffect, useState } from "react";
import Loader from "../Loader";
import styled from "styled-components";
import Footer_en from "./Footer_en";
import Header_en from "./Header_en";

const Tableauais_en = () => {
  const StyledHeading = styled.h6`
    position: relative;
    font-size: 100px;
    color: #008bcd;

    &::before {
      content: "—";
      font-size: inherit;
      color: #008bcd;
      display: block;
    }
  `;
  // State to control visibility
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    //switch language to english
    document.documentElement.lang = "en";
    // Delay the visibility of the component
    const timer = setTimeout(() => {
      setIsVisible(true); // Set to visible after the delay
    }, 200);

    return () => clearTimeout(timer); // Clean up on unmount
  }, []);
  return (
    <div>
      <div>
        <Header_en />
      </div>
      <Loader isVisible={isVisible} />
      <div>
        {/*=================================
page-title*/}
        <section
          className="page-title bg-overlay-black-60 parallax"
          style={{ backgroundImage: "url(/assets/images/slidebat.png)" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-title-name">
                  <h1>Tableau-AIS</h1>
                </div>
                <ul className="page-breadcrumb">
                  <li>
                    <a href="/en">
                      <i className="fa fa-home" /> Home
                    </a>{" "}
                    <i className="fa fa-angle-double-right" />
                  </li>
                  <li>
                    <span>AIS-table</span>{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/*=================================
page-title */}
        {/*=================================
 feature */}

        <section
          id="presentation"
          style={{ paddingBottom: "80px", paddingTop: "100px" }}
        >
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="section-title text-center">
                <h2 className="title-effect" style={{ color: "#00356a" }}>
                  AIS Switchgear Type SME 36 kV
                </h2>
                <br />
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="who-we-are-left">
                  <div
                    className="owl-carousel"
                    data-nav-dots="true"
                    data-items={1}
                    data-md-items={1}
                    data-sm-items={1}
                    data-xs-items={1}
                    data-xx-items={1}
                  >
                    <div className="item">
                      <img
                        className="img-fluid full-width"
                        src="/assets/images/cellule trio.png"
                        alt="Cellule AIS type SME 36 KV"
                      />
                    </div>
                    <div className="item">
                      <img
                        className="img-fluid full-width"
                        src="/assets/images/cellule trio.png"
                        alt="Cellule AIS type SME 36 KV"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 sm-mt-30">
                {/** */}
                <div
                  className="bounceIn wow"
                  style={{
                    visibility: "visible",
                    animationName: "bounceIn",
                  }}
                >
                  <p>
                    Our 36 kV modular medium voltage switchgear, equipped with
                    SF6-insulated switches and air-insulated busbars, are
                    manufactured in compliance with the international standard
                    IEC-62271-200. Approved by STEG and installed in the
                    Tunisian network.
                  </p>
                  <br />
                  <ul
                    className="list list-unstyled list-hand"
                    style={{ borderRight: "0px solid white" }}
                  >
                    <li>SME01: Network panel (Incoming/Outgoing).</li>
                    <li>SME02: Transformer protection panel with fuse.</li>
                    <li> SME03: Voltage measurement panel.</li>
                    <li>SME05: Circuit breaker panel with double isolation.</li>
                  </ul>
                  <br />
                  <div style={{ textAlign: "center" }}>
                    <a className="button button-border" href="/en/contact">
                      Contact us
                    </a>
                  </div>
                </div>
                {/** */}
              </div>
            </div>
          </div>
        </section>
        <section id="tab36" className=" data-table">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <h3 style={{ color: "#00356a" }}>
                  Technical Specification SME 36 KV
                </h3>
                <StyledHeading className="h6-line"></StyledHeading>
                <br />
                <div className="table-responsive">
                  <table className="table table-1 table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Tension Nominal (KV)</th>
                        <th>Rated Voltage (KV)</th>
                        <th>36</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Niveau d'isolement assigné</td>
                        <td>Insulation level</td>
                        <td />
                      </tr>
                      <tr>
                        <td>Isolement (50HZ, 1min KV eff)</td>
                        <td>Insulation level 50HZ, 1min</td>
                        <td>70</td>
                      </tr>
                      <tr>
                        <td>Sectionnement (50HZ, 1min KV eff)</td>
                        <td>Isolation level 50HZ, 1min</td>
                        <td>80</td>
                      </tr>
                      <tr>
                        <td>Isolement (1.2/50µs)</td>
                        <td>Insulation level 1.2/50µs</td>
                        <td>170</td>
                      </tr>
                      <tr>
                        <td>Sectionnement (1.2/50µs)</td>
                        <td>Isolation level 1.2/50µs</td>
                        <td>195</td>
                      </tr>
                      <tr>
                        <td>Courant de courte durée</td>
                        <td>Short time withstand current</td>
                        <td />
                      </tr>
                      <tr>
                        <td>Valeur efficace (KA 1s)</td>
                        <td>r.m.s value</td>
                        <td>16</td>
                      </tr>
                      <tr>
                        <td>Valeur créte (KAc)</td>
                        <td>peak value</td>
                        <td>40</td>
                      </tr>
                      <tr>
                        <td>Courant assigne de la cellule (A)</td>
                        <td>Rated current (A)</td>
                        <td>630</td>
                      </tr>
                      <tr>
                        <td>Frequence (Hz)</td>
                        <td>Frequency (Hz)</td>
                        <td>50</td>
                      </tr>

                      <tr>
                        <td>
                          Pouvoir de fermeture du sectionneur a la terre (KA)
                        </td>
                        <td>Earting switch Making Capacity (KA)</td>
                        <td>40</td>
                      </tr>
                      <tr>
                        <td>Degre de protection</td>
                        <td>Degree of protection</td>
                        <td>IP3X</td>
                      </tr>
                      <tr>
                        <td>Indice de protection mecanique</td>
                        <td>Mechanical protection index</td>
                        <td>IK07</td>
                      </tr>

                      <tr>
                        <td>Isolement jeu de barres</td>
                        <td>Busbar Insulation</td>
                        <td>AIR</td>
                      </tr>
                      <tr>
                        <td>Classification arc interne IAC</td>
                        <td>IAC Internal arc classification</td>
                        <td>16KA, 1s, AFL</td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <br />
                  <div style={{ textAlign: "end" }}>
                    <a
                      className="button button-border"
                      href="/assets/brochures/TABLEAU AIS 36kV SME.PDF"
                    >
                      Brochure
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="configuration" style={{ paddingBottom: "80px" }}>
          <div className="container">
            <div className="row mt-60">
              <div className="col-lg-12 col-md-12">
                <h4 className="mb-30">Configuration</h4>
                <div className="isotope columns-2 popup-gallery no-title">
                  <div className="grid-item">
                    <div className="portfolio-item">
                      <img src="/assets/images/sme/SME01.jpg" alt="SME01" />

                      <a
                        className="popup portfolio-img"
                        href="/assets/images/sme/bigsme01.png"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>
                  </div>
                  <div className="grid-item">
                    <div className="portfolio-item">
                      <img src="/assets/images/sme/SME02.jpg" alt="SME02" />

                      <a
                        className="popup portfolio-img"
                        href="/assets/images/sme/bigsme02.png"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>
                  </div>
                  <div className="grid-item">
                    <div className="portfolio-item">
                      <img src="/assets/images/sme/SME03.jpg" alt="SME03" />

                      <a
                        className="popup portfolio-img"
                        href="/assets/images/sme/bigsme03.png"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>
                  </div>
                  {/* <div className="grid-item">
                    <div className="portfolio-item">
                      <img src="/assets/images/sme/SME04.jpg" alt="" />
                      
                      <a
                        className="popup portfolio-img"
                        href="/assets/images/sme/bigsme04.png"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>
                  </div> */}
                  <div className="grid-item">
                    <div className="portfolio-item">
                      <img src="/assets/images/sme/SME05.jpg" alt="SME05" />

                      <a
                        className="popup portfolio-img"
                        href="/assets/images/sme/bigsme05.png"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>
                  </div>
                  {/* <div className="grid-item">
                    <div className="portfolio-item">
                      <img src="/assets/images/sme/SME06.jpg" alt="" />
                     
                      <a
                        className="popup portfolio-img"
                        href="/assets/images/sme/bigsme06.png"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>
                  </div> */}
                </div>
                {/* <div className="isotope columns-3 popup-gallery no-title">
                  <div className="grid-item">
                    <div className="portfolio-item">
                      <img src="/assets/images/sme/SME07.jpg" alt="" />

                      <a
                        className="popup portfolio-img"
                        href="/assets/images/sme/bigsme07.png"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>
                  </div>
                  <div className="grid-item">
                    <div className="portfolio-item">
                      <img src="/assets/images/sme/SME08.jpg" alt="" />
                      
                      <a
                        className="popup portfolio-img"
                        href="/assets/images/sme/bigsme08.png"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>
                  </div>
                  <div className="grid-item">
                    <div className="portfolio-item">
                      <img src="/assets/images/sme/SME09.jpg" alt="" />
                      
                      <a
                        className="popup portfolio-img"
                        href="/assets/images/sme/bigsme09.png"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>
                  </div>
                  <div className="grid-item">
                    <div className="portfolio-item">
                      <img src="/assets/images/sme/SME10.jpg" alt="" />
                      
                      <a
                        className="popup portfolio-img"
                        href="/assets/images/sme/bigsme10.png"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>
                  </div>
                  <div className="grid-item">
                    <div className="portfolio-item">
                      <img src="/assets/images/sme/SME11.jpg" alt="" />
                      
                      <a
                        className="popup portfolio-img"
                        href="/assets/images/sme/bigsme11.png"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>
                  </div>
                  <div className="grid-item">
                    <div className="portfolio-item">
                      <img src="/assets/images/sme/SME12.jpg" alt="" />

                      <a
                        className="popup portfolio-img"
                        href="/assets/images/sme/bigsme12.png"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </section>
        {/*=================================feature */}
      </div>
      <div>
        <Footer_en />
      </div>
    </div>
  );
};

export default Tableauais_en;
